/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportService from "../../services/reportService";
import { formatPrice } from "../../utils";
import PdfTotalActivityReport from "../../components/prints/report/pdfTotalActivityReport";
import React from "react";
import { AuthContext } from "../../provider/authProvider";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import BranchDropdown from "../../components/dropdowns/branchDropdown";

const TotalActivityReport = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const { user } = useContext(AuthContext);
    const userPermissions = user?.permissions || [];
    const allBranchPermission = userPermissions?.some(p => p.value === 'allBranches');
    const [selectedBranch, setSelectedBranch] = useState(null);

    const [report, setReport] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const fetchReport = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const filters = {
                branchId: selectedBranch?.id,
            };

            const data = await ReportService.fetchActivity(filters);
            setReport(data);

        } catch (error) {
            console.error('Error fetching report:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const resetFilter = () => {
        setSelectedBranch(null);
    };

    useEffect(() => {
        fetchReport();
    }, [selectedBranch]);

    return (
        <Box sx={{
            p: isTablet ? 1 : 4,
            backgroundColor: theme.palette.secondary.main,
        }}>

            {/* Filter row */}
            {
                allBranchPermission && <Box
                    sx={{
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        height: 60,
                        width: isTablet ? '100%' : '45%'
                    }}
                >
                    <Box sx={{ px: 2 }}>
                        <FilterAltOutlinedIcon />
                    </Box>
                    <Divider orientation="vertical" />
                    <Box width={isTablet ? '60%' : '50%'}>
                        <BranchDropdown
                            isFilter={true}
                            selectedBranch={selectedBranch}
                            setSelectedBranch={setSelectedBranch}
                        />
                    </Box>

                    <Divider orientation="vertical" />
                    <Box
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            color: theme.palette.text.red,
                            px: 2,
                            cursor: 'pointer',
                        }}
                        onClick={resetFilter}
                    >
                        <ReplayOutlinedIcon />
                        <Box width={3}></Box>
                        <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                    </Box>
                </Box>
            }

            <Box
                sx={{
                    display: 'flex',
                    // justifyContent: 'center'
                }}>
                <Box
                    sx={{
                        width: isTablet ? '100%' : '70%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        py: 4,
                        px: isTablet ? 1 : 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('totalBalanceSheet')}
                        </Typography>
                    </Box>

                    <Box my={6}>
                        <Divider sx={{ mt: 2 }} />

                        {/* title */}
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%'
                            }}>
                            <Box
                                sx={{
                                    width: '50%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2,
                                    bgcolor: theme.palette.customGrey.insideInput,
                                }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('cashBalance')}
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: '50%',
                                borderRight: 1,
                                borderLeft: 1,
                                borderColor: theme.palette.customGrey.borderInput,
                                px: 1,
                                py: 2,
                                bgcolor: theme.palette.customGrey.insideInput,
                            }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('liabilities')}
                                </Typography>
                            </Box>

                        </Box>
                        <Divider />

                        {/* cashes */}
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%'
                            }}>
                            <Box
                                sx={{
                                    width: '50%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2
                                }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('walletMoney')} : {formatPrice(report.totalBranchWallet)}
                                </Typography>

                                <Typography id="transition-modal-title" variant="body1" mt={2}>
                                    {t('driverWallet')} : {formatPrice(report.totalDriverWallet)}
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: '50%',
                                borderRight: 1,
                                borderLeft: 1,
                                borderColor: theme.palette.customGrey.borderInput,
                                px: 1,
                                py: 2
                            }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('pageWallet')} : {formatPrice(report.totalPageWallet)}
                                </Typography>
                            </Box>

                        </Box>
                        <Divider />

                        {/* totals */}
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%'
                            }}>
                            <Box
                                sx={{
                                    width: '50%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2
                                }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('total')} : {formatPrice(report.totalWealth)}
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: '50%',
                                borderRight: 1,
                                borderLeft: 1,
                                borderColor: theme.palette.customGrey.borderInput,
                                px: 1,
                                py: 2
                            }}>
                                <Typography id="transition-modal-title" variant="body1">
                                    {t('total')} : {formatPrice(report.totalPageWallet)}
                                </Typography>
                            </Box>

                        </Box>

                        <Divider />

                        {/* totals wealth */}
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%'
                            }}>
                            <Box
                                sx={{
                                    width: '50%',
                                    borderRight: 1,
                                    borderLeft: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    px: 1,
                                    py: 2
                                }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {t('totalWealth')}:
                                </Typography>
                            </Box>

                            <Box sx={{
                                width: '50%',
                                borderRight: 1,
                                borderLeft: 1,
                                borderColor: theme.palette.customGrey.borderInput,
                                px: 1,
                                py: 2
                            }}>
                                <Typography id="transition-modal-title" variant="body1" fontWeight='bold'>
                                    {formatPrice(report.netWealth)}
                                </Typography>
                            </Box>

                        </Box>

                        <Divider />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: '100%'
                        }}
                    >
                        <PdfTotalActivityReport
                            data={{
                                branch: selectedBranch,
                            }} />
                    </Box>
                </Box>
            </Box>


        </Box>
    );
}

export default TotalActivityReport;